export default __webpack_public_path__ + "static/media/icon-error.7c3beea2.svg";